import {Component, Inject, OnInit} from "@angular/core";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {FiltreOption,TypeFiltreDigit} from '@domain/admin/entreprise/analytique/filtre-option';
import {ListView,TypeComparaison} from "@domain/common/list-view";
import {Sorting} from "@domain/common/list-view/sorting";
import {TranslateService} from "@ngx-translate/core";
import {AjoutFiltreItemComponent} from "./ajout-filtre-item/ajout-filtre-item.component";
import {PrestFiltre} from "@domain/prestation/prest-filtre";
import {FiltreListItemComponent} from "@components/admin/frais/prestations/prestation-detail/filtres/filtre-list-item.component";
import {ToastrService} from "ngx-toastr";

/**
 * Composant permettant d'afficher les informations d'un filtre à ajouter à la prestation
 */
@Component({
    host: {'data-test-id': 'popin-ajout-filtres'},
    templateUrl: './popin-ajout-filtres.component.html',
    styleUrls: ['./popin-ajout-filtres.component.scss']
})
export class PopinAjoutFiltresComponent implements OnInit {
    /** Type de filtres possibles */
    protected readonly TypeFiltre = TypeFiltreDigit;

    /** Permet de savoir dans quel état on est : affichage des types de filtres ou alors affichage des filtres */
    showOptions: boolean = true;

    /** Option sélectionnée */
    optionSelected: FiltreOption;

    /** Liste des filtres */
    listeFiltres: ListView<PrestFiltre, AjoutFiltreItemComponent>;

    /** Filtre par exception */
    isParException: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        private translateService: TranslateService,
        private matDialogRef: MatDialogRef<PopinAjoutFiltresComponent>,
        private toastrService: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: {liste: ListView<PrestFiltre,FiltreListItemComponent>,idPrestation: number}
    ) { }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        //Si la liste ne contient qu'une seule option
        if (this.data.liste.extraOptions.options?.length == 1) {
            //Masquage immédiat des choix d'option
            this.showOptions = false;

            //On la sélectionne directement
            this.selectOption(this.data.liste.extraOptions.options[0]);
        }
    }

    /**
     * Méthode appelée lors de la sélection d'un type de filtre
     *
     * @param option Type de filtre sélectionné
     */
    selectOption(option: FiltreOption){
        //Mise à jour de l'option sélectionnée
        this.optionSelected = option;

        //Récupération des filtres correspondant au type sélectionné
        this.listeFiltres = new ListView<PrestFiltre,AjoutFiltreItemComponent>({
            uri: `/controller/AdminPrestation/findAllFiltreByType/${this.data.idPrestation}/${this.optionSelected.valeur}`,
            title: this.optionSelected.libelleListe,
            component: AjoutFiltreItemComponent,
            isFilter: true,
            defaultOrder: 'libelle',
            listeFilters: [
                {
                    clef: 'libelle',
                    title: this.translateService.instant('admin.frais.prestations.detail.filtres.listeFiltres.libelle'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE]
                }
            ],
            extraOptions: {
                avatar: this.optionSelected.avatar,
                selectEvent: this.selectFiltre.bind(this)
            }
        });

        //Définition des colonnes de tri
        this.listeFiltres.columns = [
            { key: 'libelle', title: 'admin.frais.prestations.detail.filtres.listeFiltres.libelle' }
        ];

        //Ajout du tri de la liste selon l'ordre voulu
        this.listeFiltres.sorting = new Sorting(this.listeFiltres.columns, "libelle");

        //Passage à l'écran de visualisation des filtres disponibles
        this.showOptions = false;
    }

    /**
     * Méthode appelée lors du passage de la liste des filtres à la liste des types de filtres
     */
    onGoBack() {
        //Passage à l'écran de visualisation de la liste des types de filtres
        this.showOptions = true;
    }

    /**
     * Méthode appelée lors de la sélection d'un filtre
     *
     * @param filtre filtre sélectionné
     */
    selectFiltre(filtre: PrestFiltre) {
        //Si le filtre existe déjà sur cette prestation
        if (filtre.usedHere) {
            //On affiche un message d'erreur
            this.toastrService.error(this.translateService.instant('admin.frais.prestations.detail.filtres.listeFiltres.filtreDejaPresent'));
        } else {
            //Sinon, détermination du modificateur
            const modificateur: string = (this.optionSelected.valeur == TypeFiltreDigit.FILTRE_MOT_CLE || this.optionSelected.valeur == TypeFiltreDigit.FILTRE_ORGANISATION) ? (this.isParException ? '-' : '+') : undefined;

            //MAJ du modificateur
            filtre.modificateur = modificateur;

            //Fermeture de la boîte de dialogue en renvoyant le filtre sélectionné
            this.matDialogRef.close(filtre);
        }
    }
}